module.exports = __webpack_public_path__ + "static/media/Cairo-SemiBold.db88defa.woff";